import PricingCardStarter from "@/features/billing/ui/pricing/PricingCardStarter";
import PricingCardPro from "@/features/billing/ui/pricing/PricingCardPro";
import PricingCardEnterprise from "@/features/billing/ui/pricing/PricingCardEnterprise";

const PricingCards = () => {
  return (
    <div
      className={
        "non-scroll mt-[38px] flex w-full flex-wrap justify-between gap-[46px] overflow-x-scroll sm:flex-nowrap sm:gap-0 sm:gap-[12px] sm:pt-[16px]"
      }
    >
      <PricingCardStarter />
      <PricingCardPro />
      <PricingCardEnterprise />
    </div>
  );
};

export default PricingCards;
